export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  // isCheckable: false,
  // isCardView: true,
  isDetailed: true,
  detailRowComponent: 'mf-detail-row',
  customRowKey: 'uid',
  fields: [
		 {
      name: 'viewBIM',
      width: '48px',
      title: '',
    },
		 {
      name: 'notes',
      title: '',
      defaultVisible: true,
      width: '48px',
      id: 'notes',
    },
		{
			name: 'field-generic-input',
			width: '400px',
			title: 'Item',
			prop: 'name',
			id: 'name',
			inputProps: {
				type: 'text',
        disableEdit: false,
      },
		},
		{
			name: 'field-generic-input',
			width: '125px',
			title: 'Item Id',
			id: 'customId',
			prop: 'customId',
			inputProps: {
				type: 'text',
        disableEdit: false,
      },
		},
		{
	    name: 'quantity',
      width: '48px',
      title: 'QTY',
      id: 'quantity',
	  classRight: 'is-pulled-right',
      prop: 'quantity',
		},
		{
      name: 'field-install-locs-icon',
      title: 'Install',
      width: '48px',
      id: 'installLocation',
    },
		{
			name: 'field-lvl-zone',
			prop: 'level',
			width: '100px',
			title: 'Level',
			id: 'level',
			inputProps: {
				options: 'levels',
				isEditing: true,
			},
    },
    {
			name: 'field-lvl-zone',
			prop: 'zone',
			width: '100px',
			title: 'Zone',
			id: 'zone',
			inputProps: {
				options: 'zones',
				isEditing: true,
			},
    },
		{
      name: 'templateSelect',
      width: '160px',
      title: 'Material Template',
      id: 'template',
    },
  ],
};
